<div class="dashboard-contratos">
  <ng-container *ngIf="usa_contrato; else contratoNaoHabilitado">
  <header class="dashboard-hero">
    <div>
      <span class="new-badge">NEW</span>
      <h1>Dashboard de Contratos</h1>
      <p>Objetivo mensal x realizado dos ultimos 3 meses por cliente e produto.</p>
    </div>

    <div class="dashboard-filtros">
      <input type="text" placeholder="Buscar cliente ou ERP" [(ngModel)]="clienteFiltro" />
      <select [(ngModel)]="status">
        <option value="ATIVO">Ativos</option>
        <option value="">Todos</option>
        <option value="INATIVO">Inativos</option>
        <option value="ENCERRADO">Encerrados</option>
      </select>
      <select [(ngModel)]="vendedorFiltro">
        <option value="">Todos vendedores</option>
        <option *ngFor="let vendedor of vendedores" [value]="vendedor">{{ vendedor }}</option>
      </select>
      <select [(ngModel)]="resultadoFiltro">
        <option value="">Todos contratos</option>
        <option value="ATINGIDO">Atingido</option>
        <option value="NAO_ATINGIDO">Nao atingido</option>
      </select>
      <button type="button" class="btn btn-primary" (click)="carregar()">Atualizar</button>
    </div>
  </header>

  <section class="resumo-grid">
    <div class="resumo-card">
      <span>Objetivo mes atual</span>
      <strong>{{ dashboard.meta_mes_atual | number:'1.2-2' }}</strong>
    </div>

    <div class="resumo-card">
      <span>Realizado mes atual</span>
      <strong>{{ dashboard.realizado_mes_atual | number:'1.2-2' }}</strong>
    </div>

    <div class="resumo-card" [ngClass]="classePercentual(dashboard.atingimento_mes_atual)">
      <span>Atingimento</span>
      <strong>{{ dashboard.atingimento_mes_atual | number:'1.0-1' }}%</strong>
    </div>
  </section>

  <section class="contratos-resultados">
    <div class="resultado-card resultado-linha" *ngFor="let linha of linhasFiltradas" [ngClass]="classePercentual(linha.atingimento_mes_atual)">
      <button type="button" class="resultado-resumo" (click)="alternarDetalhes(linha)">
        <div class="resultado-cliente">
          <h2>{{ linha.cliente_nome }}</h2>
          <span>{{ linha.nome_contrato }} | ERP: {{ linha.codigo_no_erp_do_cliente || '-' }}</span>
          <small>Vendedor: {{ linha.vendedor_nome || 'Sem vendedor' }}</small>
        </div>

        <div class="resultado-produto">
          <span class="produto-pill">{{ linha.produto_nome }}</span>
          <small>{{ linha.produto_codigo || '-' }}</small>
        </div>

        <div class="resultado-numero">
          <small>Objetivo</small>
          <strong>{{ linha.objetivo_mensal | number:'1.2-2' }}</strong>
        </div>

        <div class="resultado-numero">
          <small>Realizado</small>
          <strong>{{ linha.realizado_mes_atual | number:'1.2-2' }}</strong>
        </div>

        <div class="resultado-numero">
          <small>% atual</small>
          <strong>{{ linha.atingimento_mes_atual | number:'1.0-1' }}%</strong>
        </div>

        <span class="status-pill" [ngClass]="classePercentual(linha.atingimento_mes_atual)">
          {{ statusContrato(linha) }}
        </span>

        <span class="expand-icon">{{ estaExpandido(linha) ? '-' : '+' }}</span>
      </button>

      <div class="meses-grid" *ngIf="estaExpandido(linha)">
        <div class="mes-card" *ngFor="let mes of linha.meses" [ngClass]="classePercentual(mes.atingimento)">
          <div class="mes-top">
            <strong>{{ labelMes(mes) }}</strong>
            <span>{{ mes.atingimento | number:'1.0-1' }}%</span>
          </div>

          <div class="progress-contrato">
            <div [style.width]="largura(mes.atingimento)"></div>
          </div>

          <div class="mes-valores">
            <span>Objetivo: {{ mes.objetivo | number:'1.2-2' }}</span>
            <span>Realizado: {{ mes.realizado | number:'1.2-2' }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="empty-state" *ngIf="!carregando && linhasFiltradas.length === 0">
      Nenhum contrato encontrado para exibir no dashboard.
    </div>
  </section>
  </ng-container>

  <ng-template #contratoNaoHabilitado>
    <section class="contrato-apresentacao">
      <div class="apresentacao-copy">
        <span class="new-badge">NEW</span>
        <h1>Contratos Napis</h1>
        <p>Controle objetivos mensais por cliente e produto, acompanhe realizado dos ultimos meses e identifique rapidamente contratos atingidos ou em risco.</p>
        <div class="apresentacao-alerta">
          Esta funcao ainda nao esta habilitada para o seu usuario. Entre em contato com o suporte para agendar uma apresentacao.
        </div>
      </div>

      <div class="apresentacao-grid">
        <article>
          <strong>Cadastro do contrato</strong>
          <span>Vincule cliente, vendedor, produto e meta mensal de compra.</span>
        </article>
        <article>
          <strong>Objetivo x realizado</strong>
          <span>Veja o mes atual e abra o historico dos ultimos 3 meses.</span>
        </article>
        <article>
          <strong>Alertas comerciais</strong>
          <span>Tags de atingido e nao atingido ajudam o time a priorizar acao.</span>
        </article>
      </div>

      <div class="mock-contratos">
        <div class="mock-card atingido">
          <div>
            <strong>AUTO POSTO EXEMPLO</strong>
            <span>Oleo Diesel S10</span>
          </div>
          <b>112%</b>
          <small>Atingido</small>
        </div>
        <div class="mock-card risco">
          <div>
            <strong>CLIENTE EM ACOMPANHAMENTO</strong>
            <span>Arla 32</span>
          </div>
          <b>48%</b>
          <small>Nao atingido</small>
        </div>
      </div>
    </section>
  </ng-template>
</div>
